import React, { useState, useContext, useEffect } from 'react';
import './AdditionalFilter.scss';
import { ReactComponent as ArrowDown } from '../../assets/icons/keyboard_arrow_down-24px.svg';
import clsx from 'clsx';
import RoverFilter from './Items/RoverFilter/RoverFilter';
import EarthDateFilter from './Items/EarthDateFilter/EarthDateFilter';
import SolFilter from './Items/SolFilter/SolFilter';
import { CSSTransitionGroup } from 'react-transition-group';
import { FilterStore } from '../../App';

export default () => {
  const [open, setOpen] = useState(false);

  const currentFilter = useContext(FilterStore).filter;

  useEffect(() => {
    if (currentFilter.firstFetched) {
      setOpen(false);
    }
  }, [currentFilter.firstFetched])

  return (
    <div className="additional-filter">
      <button
        className="additional-filter__button"
        onClick={() => setOpen(!open)}
      >
        <ArrowDown className={clsx({
          'additional-filter__button__arrow': true,
          'additional-filter__button__arrow--open': open
        })} />
        <span className="additional-filter__button__text">Additonal filter</span>
      </button>
      <CSSTransitionGroup
        transitionName="additional-filter__items--animation"
        transitionEnterTimeout={450}
        transitionLeaveTimeout={600}>
        {open
          ? (
            <div className="additional-filter__items">
              <RoverFilter />
              {!currentFilter.toSol && !currentFilter.fromSol
                ? <EarthDateFilter />
                : null}
              {!currentFilter.toDate && !currentFilter.fromDate
                ? <SolFilter />
                : null}
            </div>
          )
          : null}
      </CSSTransitionGroup>

    </div>
  )
}